var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:{
        'callout': true,
        'callout-success': _vm.type === 'success',
        'callout-warning': _vm.type === 'warning',
        'callout-info': _vm.type === 'info',
        'callout-danger': _vm.type === undefined || _vm.type ==='danger',
        'callout-visible': _vm.show,
        'callout-hidden': !_vm.show,
    },attrs:{"role":"alert"}},[(_vm.message)?_c('h4',[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")]):_vm._e(),_vm._l((_vm.messages),function(error){return _c('p',{key:error},[_vm._v("\n        "+_vm._s(error)+"\n    ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }